import { parseLumberFromMaterial } from "./lumberNominal";
import { normalizeSlotLabel } from "./slotLabel";
import type { VariantConfig } from "./variantConfig";

export type SeedableRecipeLine = {
  line_kind: "material" | "component" | "use";
  material_id: string | null;
  material_code: string;
  material_name: string;
  slot_label: string;
};

export type NamedVariantSeedFromRecipe = {
  transform: VariantConfig;
  exampleSlot: string;
  exampleFromNominal: string;
  exampleMaterialLabel: string;
  /** Distinct non-empty slots on the example recipe (for picker priority). */
  recipeSlots: string[];
};

/** Prefill a transform rule from the first material BOM line on an example recipe. */
export function seedNamedVariantTransformFromRecipeLines(
  lines: readonly SeedableRecipeLine[],
): NamedVariantSeedFromRecipe | null {
  const first = lines.find(
    (ln) => ln.line_kind === "material" && (ln.material_id || ln.material_code || ln.material_name),
  );
  if (!first) return null;

  const lumber = parseLumberFromMaterial({
    code: first.material_code || "",
    name: first.material_name || "",
  });
  const fromNominal = lumber?.nominal ?? "";
  const slot = normalizeSlotLabel(first.slot_label || "");
  const exampleMaterialLabel =
    [first.material_code, first.material_name].filter(Boolean).join(" — ") || "material";
  const recipeSlots = [
    ...new Set(
      lines
        .filter((ln) => ln.line_kind === "material")
        .map((ln) => normalizeSlotLabel(ln.slot_label || ""))
        .filter((s): s is string => Boolean(s)),
    ),
  ];

  return {
    transform: {
      mode: "transform",
      rules: [
        {
          slots: slot ? [slot] : [],
          fromNominal,
          toNominal: "",
        },
      ],
    },
    exampleSlot: slot,
    exampleFromNominal: fromNominal,
    exampleMaterialLabel,
    recipeSlots,
  };
}
